import { useEventsPublisher } from 'event-bus';
import { useBackendApi } from './backendApi';

export const CLIENT_APP_INVITATION_SENT = 'CLIENT_APP_INVITATION_SENT';

export function useClientAppInvitationService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  const sendInvitation = async (personId: number): Promise<void> => {
    await nekstApi.post(`/people/${personId}/clientappinvitation`);
    eventsPublisher.publish(CLIENT_APP_INVITATION_SENT, { personId });
  };

  return {
    sendInvitation,
  };
}
